import "./HeroStyles.css"

function Hero(props){
    return(
        <>
            <div className={props.cName}>
                <img className="hero-img" alt="HelpImg" src={props.heroImg}/>
            
                <div className="herocontent-text">
                    <h1>{props.title}</h1>
                    <p>{props.text}</p>
                    <a href={props.url} className={props.btnClass}>{props.btnText}</a>
                </div>    
            </div>
        </>
    )
}

export default Hero;